import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
/* eslint-disable */
export default new Vuex.Store({
  state: {
    isSidebarActive: false,
    themeColor: "#2962ff",
    pagination: 10,
    // url_api:"http://localhost:5000/",
    // url_api_live:"http://localhost:2000/",
    // url_api_img:"http://localhost:5000/",
    url_api:"http://10.100.120.117:5000/",
    url_api_live:"http://10.100.120.117:2000/",
    url_api_img:"http://10.100.120.117:5000/",
    messages:{
      A:"Total de dispositivos admitidos en el sistema.",
      B:"Total de dispositivos activos en los últimos 5 minutos.",
      C:"Total de dispositivos inactivos en los últimos 5 minutos.",
      D:"Total de equipos que están pre configurados y pendientes de despliegue en vehículo móvil",
      E:"Total de dispositivos activos pero con una cámara con problema (exceptuando la trasera).",
      F:"Total de dispositivos activos pero con dos más cámaras con problemas o la cámara trasera con problemas.",
    },
    user: '',
    role: '',
  },
  mutations: {
    //This is for Sidbar trigger in mobile
    IS_SIDEBAR_ACTIVE(state, value) {
        state.isSidebarActive = value;
    }
  },  
  actions: {
    
  },
  getters:{
    
  }
})
